module.exports = __webpack_public_path__ + "img/39-s.ac121ab9.png";